import { render, staticRenderFns } from "./info.vue?vue&type=template&id=056b6ef2&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports